export default [
  { id: '30', gentilico: 'Brasileira', nomePais: 'Brasil', sigla: 'BR' },
  { id: '1', gentilico: 'Afegã', nomePais: 'Afeganistão', sigla: 'AF' },
  { id: '2', gentilico: 'Sul-africana', nomePais: 'África do Sul', sigla: 'ZA' },
  { id: '3', gentilico: 'Albanesa', nomePais: 'Albânia', sigla: 'AL' },
  { id: '4', gentilico: 'Alemã', nomePais: 'Alemanha', sigla: 'DE' },
  { id: '5', gentilico: 'Andorrana', nomePais: 'Andorra', sigla: 'AD' },
  { id: '6', gentilico: 'Angolana', nomePais: 'Angola', sigla: 'AO' },
  { id: '7', gentilico: 'Anguilana', nomePais: 'Anguilla', sigla: 'AI' },
  { id: '8', gentilico: 'De antártida', nomePais: 'Antártida', sigla: 'AQ' },
  { id: '9', gentilico: 'Antiguana', nomePais: 'Antígua e Barbuda', sigla: 'AG' },
  { id: '10', gentilico: 'Saudita', nomePais: 'Arábia Saudita', sigla: 'SA' },
  { id: '11', gentilico: 'Argelina', nomePais: 'Argélia', sigla: 'DZ' },
  { id: '12', gentilico: 'Argentina', nomePais: 'Argentina', sigla: 'AR' },
  { id: '13', gentilico: 'Armênia', nomePais: 'Armênia', sigla: 'AM' },
  { id: '14', gentilico: 'Arubana', nomePais: 'Aruba', sigla: 'AW' },
  { id: '15', gentilico: 'Australiana', nomePais: 'Austrália', sigla: 'AU' },
  { id: '16', gentilico: 'Austríaca', nomePais: 'Áustria', sigla: 'AT' },
  { id: '17', gentilico: 'Azerbaidjana', nomePais: 'Azerbaijão', sigla: 'AZ' },
  { id: '18', gentilico: 'Bahamense', nomePais: 'Bahamas', sigla: 'BS' },
  { id: '19', gentilico: 'Bareinita', nomePais: 'Bahrein', sigla: 'BH' },
  { id: '20', gentilico: 'Bengali', nomePais: 'Bangladesh', sigla: 'BD' },
  { id: '21', gentilico: 'Barbadiana', nomePais: 'Barbados', sigla: 'BB' },
  { id: '22', gentilico: 'Bielorrussa', nomePais: 'Belarus', sigla: 'BY' },
  { id: '23', gentilico: 'Belga', nomePais: 'Bélgica', sigla: 'BE' },
  { id: '24', gentilico: 'Belizenha', nomePais: 'Belize', sigla: 'BZ' },
  { id: '25', gentilico: 'Beninense', nomePais: 'Benin', sigla: 'BJ' },
  { id: '26', gentilico: 'Bermudense', nomePais: 'Bermudas', sigla: 'BM' },
  { id: '27', gentilico: 'Boliviana', nomePais: 'Bolívia', sigla: 'BO' },
  { id: '28', gentilico: 'Bósnia', nomePais: 'Bósnia-Herzegóvina', sigla: 'BA' },
  { id: '29', gentilico: 'Botsuana', nomePais: 'Botsuana', sigla: 'BW' },
  { id: '31', gentilico: 'Bruneana', nomePais: 'Brunei', sigla: 'BN' },
  { id: '32', gentilico: 'Búlgara', nomePais: 'Bulgária', sigla: 'BG' },
  { id: '33', gentilico: 'Burquinense', nomePais: 'Burkina Fasso', sigla: 'BF' },
  { id: '34', gentilico: 'Burundinesa', nomePais: 'Burundi', sigla: 'BI' },
  { id: '35', gentilico: 'Butanesa', nomePais: 'Butão', sigla: 'BT' },
  { id: '36', gentilico: 'Cabo-verdiana', nomePais: 'Cabo Verde', sigla: 'CV' },
  { id: '37', gentilico: 'Camaronesa', nomePais: 'Camarões', sigla: 'CM' },
  { id: '38', gentilico: 'Cambojana', nomePais: 'Camboja', sigla: 'KH' },
  { id: '39', gentilico: 'Canadense', nomePais: 'Canadá', sigla: 'CA' },
  { id: '40', gentilico: 'Canarina', nomePais: 'Canárias', sigla: 'IC' },
  { id: '41', gentilico: 'Cazaque', nomePais: 'Cazaquistão', sigla: 'KZ' },
  { id: '42', gentilico: 'De ceuta e melilla', nomePais: 'Ceuta e Melilla', sigla: 'EA' },
  { id: '43', gentilico: 'Chadiana', nomePais: 'Chade', sigla: 'TD' },
  { id: '44', gentilico: 'Chilena', nomePais: 'Chile', sigla: 'CL' },
  { id: '45', gentilico: 'Chinesa', nomePais: 'China', sigla: 'CN' },
  { id: '46', gentilico: 'Cipriota', nomePais: 'Chipre', sigla: 'CY' },
  { id: '47', gentilico: 'Cingapuriana', nomePais: 'Cingapura', sigla: 'SG' },
  { id: '48', gentilico: 'Colombiana', nomePais: 'Colômbia', sigla: 'CO' },
  { id: '49', gentilico: 'Comorense', nomePais: 'Comores', sigla: 'KM' },
  { id: '50', gentilico: 'Congolesa', nomePais: 'Congo', sigla: 'CG' },
  { id: '51', gentilico: 'Norte-coreana', nomePais: 'Coréia do Norte', sigla: 'KP' },
  { id: '52', gentilico: 'Sul-coreana', nomePais: 'Coréia do Sul', sigla: 'KR' },
  { id: '53', gentilico: 'Marfinense', nomePais: 'Costa do Marfim', sigla: 'CI' },
  { id: '54', gentilico: 'Costarriquenha', nomePais: 'Costa Rica', sigla: 'CR' },
  { id: '55', gentilico: 'Croata', nomePais: 'Croácia', sigla: 'HR' },
  { id: '56', gentilico: 'Cubana', nomePais: 'Cuba', sigla: 'CU' },
  { id: '57', gentilico: 'Curaçaense', nomePais: 'Curaçao', sigla: 'CW' },
  { id: '58', gentilico: 'Chagossiana', nomePais: 'Diego Garcia', sigla: 'DG' },
  { id: '59', gentilico: 'Dinamarquesa', nomePais: 'Dinamarca', sigla: 'DK' },
  { id: '60', gentilico: 'Djibutiana', nomePais: 'Djibuti', sigla: 'DJ' },
  { id: '61', gentilico: 'Dominiquense', nomePais: 'Dominica', sigla: 'DM' },
  { id: '62', gentilico: 'Egípcia', nomePais: 'Egito', sigla: 'EG' },
  { id: '63', gentilico: 'Salvadorenha', nomePais: 'El Salvador', sigla: 'SV' },
  { id: '64', gentilico: 'Árabe', nomePais: 'Emirados Árabes Unidos', sigla: 'AE' },
  { id: '65', gentilico: 'Equatoriana', nomePais: 'Equador', sigla: 'EC' },
  { id: '66', gentilico: 'Eritreia', nomePais: 'Eritréia', sigla: 'ER' },
  { id: '67', gentilico: 'Eslovaca', nomePais: 'Eslováquia', sigla: 'SK' },
  { id: '68', gentilico: 'Eslovena', nomePais: 'Eslovênia', 'NomePais_int': 'Slovenia', sigla: 'SI' },
  { id: '69', gentilico: 'Espanhola', nomePais: 'Espanha', sigla: 'ES' },
  { id: '70', gentilico: 'Norte-americana', nomePais: 'Estados Unidos', sigla: 'US' },
  { id: '71', gentilico: 'Estoniana', nomePais: 'Estônia', sigla: 'EE' },
  { id: '72', gentilico: 'Etíope', nomePais: 'Etiópia', sigla: 'ET' },
  { id: '73', gentilico: 'Fijiana', nomePais: 'Fiji', sigla: 'FJ' },
  { id: '74', gentilico: 'Filipina', nomePais: 'Filipinas', sigla: 'PH' },
  { id: '75', gentilico: 'Finlandesa', nomePais: 'Finlândia', sigla: 'FI' },
  { id: '76', gentilico: 'Francesa', nomePais: 'França', sigla: 'FR' },
  { id: '77', gentilico: 'Gabonesa', nomePais: 'Gabão', sigla: 'GA' },
  { id: '78', gentilico: 'Gambiana', nomePais: 'Gâmbia', sigla: 'GM' },
  { id: '79', gentilico: 'Ganense', nomePais: 'Gana', sigla: 'GH' },
  { id: '80', gentilico: 'Georgiana', nomePais: 'Geórgia', sigla: 'GE' },
  { id: '81', gentilico: 'Gibraltarina', nomePais: 'Gibraltar', sigla: 'GI' },
  { id: '82', gentilico: 'Inglesa', nomePais: 'Grã-Bretanha (Reino Unido, UK)', sigla: 'GB' },
  { id: '83', gentilico: 'Granadina', nomePais: 'Granada', sigla: 'GD' },
  { id: '84', gentilico: 'Grega', nomePais: 'Grécia', sigla: 'GR' },
  { id: '85', gentilico: 'Groenlandesa', nomePais: 'Groelândia', sigla: 'GL' },
  { id: '86', gentilico: 'Guadalupense', nomePais: 'Guadalupe', sigla: 'GP' },
  { id: '87', gentilico: 'Guamês', nomePais: 'Guam (Território dos Estados Unidos)', sigla: 'GU' },
  { id: '88', gentilico: 'Guatemalteca', nomePais: 'Guatemala', sigla: 'GT' },
  { id: '89', gentilico: 'Guernesiana', nomePais: 'Guernsey', sigla: 'GG' },
  { id: '90', gentilico: 'Guianense', nomePais: 'Guiana', sigla: 'GY' },
  { id: '91', gentilico: 'Franco-guianense', nomePais: 'Guiana Francesa', sigla: 'GF' },
  { id: '92', gentilico: 'Guineana', nomePais: 'Guiné', sigla: 'GN' },
  { id: '93', gentilico: 'Guinéu-equatoriana', nomePais: 'Guiné Equatorial', sigla: 'GQ' },
  { id: '94', gentilico: 'Guineense', nomePais: 'Guiné-Bissau', sigla: 'GW' },
  { id: '95', gentilico: 'Haitiana', nomePais: 'Haiti', sigla: 'HT' },
  { id: '96', gentilico: 'Holandês', nomePais: 'Holanda', sigla: 'NL' },
  { id: '97', gentilico: 'Hondurenha', nomePais: 'Honduras', sigla: 'HN' },
  { id: '98', gentilico: 'Hong-konguiana', nomePais: 'Hong Kong', sigla: 'HK' },
  { id: '99', gentilico: 'Húngara', nomePais: 'Hungria', sigla: 'HU' },
  { id: '100', gentilico: 'Iemenita', nomePais: 'Iêmen', sigla: 'YE' },
  { id: '101', gentilico: 'Da ilha Bouvet', nomePais: 'Ilha Bouvet', sigla: 'BV' },
  { id: '102', gentilico: 'Da ilha de Ascensão', nomePais: 'Ilha de Ascensão', sigla: 'AC' },
  { id: '103', gentilico: 'Da ilha de Clipperton', nomePais: 'Ilha de Clipperton', sigla: 'CP' },
  { id: '104', gentilico: 'Manês', nomePais: 'Ilha de Man', sigla: 'IM' },
  { id: '105', gentilico: 'Natalense', nomePais: 'Ilha Natal', sigla: 'CX' },
  { id: '106', gentilico: 'Pitcairnesa', nomePais: 'Ilha Pitcairn', sigla: 'PN' },
  { id: '107', gentilico: 'Reunionense', nomePais: 'Ilha Reunião', sigla: 'RE' },
  { id: '108', gentilico: 'Alandesa', nomePais: 'Ilhas Aland', sigla: 'AX' },
  { id: '109', gentilico: 'Caimanesa', nomePais: 'Ilhas Cayman', sigla: 'KY' },
  { id: '110', gentilico: 'Das ilhas Cocos', nomePais: 'Ilhas Cocos', sigla: 'CC' },
  { id: '111', gentilico: 'Cookense', nomePais: 'Ilhas Cook', sigla: 'CK' },
  { id: '112', gentilico: 'Faroense', nomePais: 'Ilhas Faroes', sigla: 'FO' },
  { id: '113', gentilico: 'Sul-georgiana', nomePais: 'Ilhas Geórgia do Sul e Sandwich do Sul', sigla: 'GS' },
  { id: '114', gentilico: 'Das ilhas Heard e McDonald', nomePais: 'Ilhas Heard e McDonald (Território da Austrália)', sigla: 'HM' },
  { id: '115', gentilico: 'Malvinense', nomePais: 'Ilhas Malvinas', sigla: 'FK' },
  { id: '116', gentilico: 'Norte-marianense', nomePais: 'Ilhas Marianas do Norte', sigla: 'MP' },
  { id: '117', gentilico: 'Marshallina', nomePais: 'Ilhas Marshall', sigla: 'MH' },
  { id: '118', gentilico: 'Das ilhas Menores Distantes dos Estados Unidos', nomePais: 'Ilhas Menores dos Estados Unidos', sigla: 'UM' },
  { id: '119', gentilico: 'Norfolquiana', nomePais: 'Ilhas Norfolk', sigla: 'NF' },
  { id: '120', gentilico: 'Salomônica', nomePais: 'Ilhas Salomão', sigla: 'SB' },
  { id: '121', gentilico: 'Seichelense', nomePais: 'Ilhas Seychelles', sigla: 'SC' },
  { id: '122', gentilico: 'Toquelauana', nomePais: 'Ilhas Tokelau', sigla: 'TK' },
  { id: '123', gentilico: 'Turquês', nomePais: 'Ilhas Turks e Caicos', sigla: 'TC' },
  { id: '124', gentilico: 'Virginense (USA)', nomePais: 'Ilhas Virgens (Estados Unidos)', sigla: 'VI' },
  { id: '125', gentilico: 'Virginense (UK)', nomePais: 'Ilhas Virgens (Inglaterra)', sigla: 'VG' },
  { id: '126', gentilico: 'Indiano', nomePais: 'Índia', sigla: 'IN' },
  { id: '127', gentilico: 'Indonésia', nomePais: 'Indonésia', sigla: 'ID' },
  { id: '128', gentilico: 'Iraniano', nomePais: 'Irã', sigla: 'IR' },
  { id: '129', gentilico: 'Iraquiana', nomePais: 'Iraque', sigla: 'IQ' },
  { id: '130', gentilico: 'Irlandesa', nomePais: 'Irlanda', sigla: 'IE' },
  { id: '131', gentilico: 'Islandesa', nomePais: 'Islândia', sigla: 'IS' },
  { id: '132', gentilico: 'Israelense', nomePais: 'Israel', sigla: 'IL' },
  { id: '133', gentilico: 'Italiana', nomePais: 'Itália', sigla: 'IT' },
  { id: '134', gentilico: 'Jamaicana', nomePais: 'Jamaica', sigla: 'JM' },
  { id: '135', gentilico: 'Japonesa', nomePais: 'Japão', sigla: 'JP' },
  { id: '136', gentilico: 'Jersiana', nomePais: 'Jersey', sigla: 'JE' },
  { id: '137', gentilico: 'Jordaniana', nomePais: 'Jordânia', sigla: 'JO' },
  { id: '138', gentilico: 'Kiribatiana', nomePais: 'Kiribati', sigla: 'KI' },
  { id: '139', gentilico: 'Kosovar', nomePais: 'Kosovo', sigla: 'XK' },
  { id: '140', gentilico: 'Kuwaitiano', nomePais: 'Kuait', sigla: 'KW' },
  { id: '141', gentilico: 'Laosiana', nomePais: 'Laos', sigla: 'LA' },
  { id: '142', gentilico: 'Lesota', nomePais: 'Lesoto', sigla: 'LS' },
  { id: '143', gentilico: 'Letão', nomePais: 'Letônia', sigla: 'LV' },
  { id: '144', gentilico: 'Libanesa', nomePais: 'Líbano', sigla: 'LB' },
  { id: '145', gentilico: 'Liberiana', nomePais: 'Libéria', sigla: 'LR' },
  { id: '146', gentilico: 'Líbia', nomePais: 'Líbia', sigla: 'LY' },
  { id: '147', gentilico: 'Liechtensteiniense', nomePais: 'Liechtenstein', sigla: 'LI' },
  { id: '148', gentilico: 'Lituana', nomePais: 'Lituânia', sigla: 'LT' },
  { id: '149', gentilico: 'Luxemburguesa', nomePais: 'Luxemburgo', sigla: 'LU' },
  { id: '150', gentilico: 'Macauense', nomePais: 'Macau', sigla: 'MO' },
  { id: '151', gentilico: 'Macedônio', nomePais: 'Macedônia (República Yugoslava)', sigla: 'MK' },
  { id: '152', gentilico: 'Malgaxe', nomePais: 'Madagascar', sigla: 'MG' },
  { id: '153', gentilico: 'Malaia', nomePais: 'Malásia', sigla: 'MY' },
  { id: '154', gentilico: 'Malauiano', nomePais: 'Malaui', sigla: 'MW' },
  { id: '155', gentilico: 'Maldívia', nomePais: 'Maldivas', sigla: 'MV' },
  { id: '156', gentilico: 'Malinesa', nomePais: 'Mali', sigla: 'ML' },
  { id: '157', gentilico: 'Maltesa', nomePais: 'Malta', sigla: 'MT' },
  { id: '158', gentilico: 'Marroquina', nomePais: 'Marrocos', sigla: 'MA' },
  { id: '159', gentilico: 'Martinicana', nomePais: 'Martinica', sigla: 'MQ' },
  { id: '160', gentilico: 'Mauriciana', nomePais: 'Maurício', sigla: 'MU' },
  { id: '161', gentilico: 'Mauritana', nomePais: 'Mauritânia', sigla: 'MR' },
  { id: '162', gentilico: 'Maiotense', nomePais: 'Mayotte', sigla: 'YT' },
  { id: '163', gentilico: 'Mexicana', nomePais: 'México', sigla: 'MX' },
  { id: '164', gentilico: 'Micronésia', nomePais: 'Micronésia', sigla: 'FM' },
  { id: '165', gentilico: 'Moçambicana', nomePais: 'Moçambique', sigla: 'MZ' },
  { id: '166', gentilico: 'Moldavo', nomePais: 'Moldova', sigla: 'MD' },
  { id: '167', gentilico: 'Monegasca', nomePais: 'Mônaco', sigla: 'MC' },
  { id: '168', gentilico: 'Mongol', nomePais: 'Mongólia', sigla: 'MN' },
  { id: '169', gentilico: 'Montenegrina', nomePais: 'Montenegro', sigla: 'ME' },
  { id: '170', gentilico: 'Montserratiana', nomePais: 'Montserrat', sigla: 'MS' },
  { id: '171', gentilico: 'Birmanês', nomePais: 'Myanma', sigla: 'MM' },
  { id: '172', gentilico: 'Namíbia', nomePais: 'Namíbia', sigla: 'NA' },
  { id: '173', gentilico: 'Nauruana', nomePais: 'Nauru', sigla: 'NR' },
  { id: '174', gentilico: 'Nepalesa', nomePais: 'Nepal', sigla: 'NP' },
  { id: '175', gentilico: 'Nicaraguense', nomePais: 'Nicarágua', sigla: 'NI' },
  { id: '176', gentilico: 'Nigerina', nomePais: 'Níger', sigla: 'NE' },
  { id: '177', gentilico: 'Nigeriana', nomePais: 'Nigéria', sigla: 'NG' },
  { id: '178', gentilico: 'Niueana', nomePais: 'Niue', sigla: 'NU' },
  { id: '179', gentilico: 'Norueguesa', nomePais: 'Noruega', sigla: 'NO' },
  { id: '180', gentilico: 'Neocaledônia', nomePais: 'Nova Caledônia', sigla: 'NC' },
  { id: '181', gentilico: 'Neozelandesa', nomePais: 'Nova Zelândia', sigla: 'NZ' },
  { id: '182', gentilico: 'Omani', nomePais: 'Omã', sigla: 'OM' },
  { id: '183', gentilico: 'Neerlandês caribenho', nomePais: 'Países Baixos Caribenhos', sigla: 'BQ' },
  { id: '184', gentilico: 'Palauense', nomePais: 'Palau', sigla: 'PW' },
  { id: '185', gentilico: 'Palestiniana', nomePais: 'Palestina', sigla: 'PS' },
  { id: '186', gentilico: 'Panamense', nomePais: 'Panamá', sigla: 'PA' },
  { id: '187', gentilico: 'Pauásia', nomePais: 'Papua-Nova Guiné', sigla: 'PG' },
  { id: '188', gentilico: 'Paquistanesa', nomePais: 'Paquistão', sigla: 'PK' },
  { id: '189', gentilico: 'Paraguaia', nomePais: 'Paraguai', sigla: 'PY' },
  { id: '190', gentilico: 'Peruana', nomePais: 'Peru', sigla: 'PE' },
  { id: '191', gentilico: 'Franco-polinésia', nomePais: 'Polinésia Francesa', sigla: 'PF' },
  { id: '192', gentilico: 'Polonesa', nomePais: 'Polônia', sigla: 'PL' },
  { id: '193', gentilico: 'Porto-riquenha', nomePais: 'Porto Rico', sigla: 'PR' },
  { id: '194', gentilico: 'Portuguesa', nomePais: 'Portugal', sigla: 'PT' },
  { id: '195', gentilico: 'Catarense', nomePais: 'Qatar', sigla: 'QA' },
  { id: '196', gentilico: 'Queniano', nomePais: 'Quênia', sigla: 'KE' },
  { id: '197', gentilico: 'Quirguiz', nomePais: 'Quirguistão', sigla: 'KG' },
  { id: '198', gentilico: 'Centro-africana', nomePais: 'República Centro-Africana', sigla: 'CF' },
  { id: '199', gentilico: 'Congolesa', nomePais: 'República Democrática do Congo', sigla: 'CD' },
  { id: '200', gentilico: 'Dominicana', nomePais: 'República Dominicana', sigla: 'DO' },
  { id: '201', gentilico: 'Tcheca', nomePais: 'República Tcheca', sigla: 'CZ' },
  { id: '202', gentilico: 'Romena', nomePais: 'Romênia', sigla: 'RO' },
  { id: '203', gentilico: 'Ruandesa', nomePais: 'Ruanda', sigla: 'RW' },
  { id: '204', gentilico: 'Russa', nomePais: 'Rússia (antiga URSS) - Federação Russa', sigla: 'RU' },
  { id: '205', gentilico: 'Saariana', nomePais: 'Saara Ocidental', sigla: 'EH' },
  { id: '206', gentilico: 'Miquelonesa', nomePais: 'Saint-Pierre e Miquelon', sigla: 'PM' },
  { id: '207', gentilico: 'Estadunidense', nomePais: 'Samoa Americana', sigla: 'AS' },
  { id: '208', gentilico: 'Samoana', nomePais: 'Samoa Ocidental', sigla: 'WS' },
  { id: '209', gentilico: 'Samarinês', nomePais: 'San Marino', sigla: 'SM' },
  { id: '210', gentilico: 'Santa-helenense', nomePais: 'Santa Helena', sigla: 'SH' },
  { id: '211', gentilico: 'Santa-lucense', nomePais: 'Santa Lúcia', sigla: 'LC' },
  { id: '212', gentilico: 'São-bartolomeense', nomePais: 'São Bartolomeu', sigla: 'BL' },
  { id: '213', gentilico: 'São-cristovense', nomePais: 'São Cristóvão e Névis', sigla: 'KN' },
  { id: '214', gentilico: 'Da ilha de São Martinho', nomePais: 'São Martim', sigla: 'MF' },
  { id: '215', gentilico: 'São-martinhense', nomePais: 'São Martinho', sigla: 'SX' },
  { id: '216', gentilico: 'São-tomense', nomePais: 'São Tomé e Príncipe', sigla: 'ST' },
  { id: '217', gentilico: 'São-vicentina', nomePais: 'São Vicente e Granadinas', sigla: 'VC' },
  { id: '218', gentilico: 'Senegalesa', nomePais: 'Senegal', sigla: 'SN' },
  { id: '219', gentilico: 'Serra-leonesa', nomePais: 'Serra Leoa', sigla: 'SL' },
  { id: '220', gentilico: 'Sérvia', nomePais: 'Sérvia', sigla: 'RS' },
  { id: '221', gentilico: 'Síria', nomePais: 'Síria', sigla: 'SY' },
  { id: '222', gentilico: 'Somali', nomePais: 'Somália', sigla: 'SO' },
  { id: '223', gentilico: 'Cingalesa', nomePais: 'Sri Lanka', sigla: 'LK' },
  { id: '224', gentilico: 'Suazi', nomePais: 'Suazilândia', sigla: 'SZ' },
  { id: '225', gentilico: 'Sudanesa', nomePais: 'Sudão', sigla: 'SD' },
  { id: '226', gentilico: 'Sul-sudanesa', nomePais: 'Sudão do Sul', sigla: 'SS' },
  { id: '227', gentilico: 'Sueca', nomePais: 'Suécia', sigla: 'SE' },
  { id: '228', gentilico: 'Suíça', nomePais: 'Suíça', sigla: 'CH' },
  { id: '229', gentilico: 'Surinamesa', nomePais: 'Suriname', sigla: 'SR' },
  { id: '230', gentilico: 'Svalbardense', nomePais: 'Svalbard', sigla: 'SJ' },
  { id: '231', gentilico: 'Tadjique', nomePais: 'Tadjiquistão', sigla: 'TJ' },
  { id: '232', gentilico: 'Tailandesa', nomePais: 'Tailândia', sigla: 'TH' },
  { id: '233', gentilico: 'Taiwanês', nomePais: 'Taiwan', sigla: 'TW' },
  { id: '234', gentilico: 'Tanzaniana', nomePais: 'Tanzânia', sigla: 'TZ' },
  { id: '235', gentilico: 'Do território Britânico do Oceano Índico', nomePais: 'Território Britânico do Oceano índico', sigla: 'IO' },
  { id: '236', gentilico: 'De terras Austrais e Antárticas Francesas', nomePais: 'Territórios do Sul da França', sigla: 'TF' },
  { id: '237', gentilico: 'Timorense', nomePais: 'Timor-Leste', sigla: 'TL' },
  { id: '238', gentilico: 'Togolesa', nomePais: 'Togo', sigla: 'TG' },
  { id: '239', gentilico: 'Tonganesa', nomePais: 'Tonga', sigla: 'TO' },
  { id: '240', gentilico: 'Trinitária', nomePais: 'Trinidad e Tobago', sigla: 'TT' },
  { id: '241', gentilico: 'Tristanita', nomePais: 'Tristão da Cunha', sigla: 'TA' },
  { id: '242', gentilico: 'Tunisiana', nomePais: 'Tunísia', sigla: 'TN' },
  { id: '243', gentilico: 'Turcomena', nomePais: 'Turcomenistão', sigla: 'TM' },
  { id: '244', gentilico: 'Turca', nomePais: 'Turquia', sigla: 'TR' },
  { id: '245', gentilico: 'Tuvaluana', nomePais: 'Tuvalu', sigla: 'TV' },
  { id: '246', gentilico: 'Ucraniana', nomePais: 'Ucrânia', sigla: 'UA' },
  { id: '247', gentilico: 'Ugandense', nomePais: 'Uganda', sigla: 'UG' },
  { id: '248', gentilico: 'Uruguaia', nomePais: 'Uruguai', sigla: 'UY' },
  { id: '249', gentilico: 'Uzbeque', nomePais: 'Uzbequistão', sigla: 'UZ' },
  { id: '250', gentilico: 'Vanuatuense', nomePais: 'Vanuatu', sigla: 'VU' },
  { id: '251', gentilico: 'Vaticana', nomePais: 'Vaticano', sigla: 'VA' },
  { id: '252', gentilico: 'Venezuelana', nomePais: 'Venezuela', sigla: 'VE' },
  { id: '253', gentilico: 'Vietnamita', nomePais: 'Vietnã', sigla: 'VN' },
  { id: '254', gentilico: 'Wallisiana', nomePais: 'Wallis e Futuna', sigla: 'WF' },
  { id: '255', gentilico: 'Zambiana', nomePais: 'Zâmbia', sigla: 'ZM' },
  { id: '256', gentilico: 'Zimbabuana', nomePais: 'Zimbábue', sigla: 'ZW' }
]



// WEBPACK FOOTER //
// ./src/constants/gentilico.js